import { render, staticRenderFns } from "./integral.vue?vue&type=template&id=79715748&scoped=true"
import script from "./integral.vue?vue&type=script&lang=js"
export * from "./integral.vue?vue&type=script&lang=js"
import style0 from "./integral.vue?vue&type=style&index=0&id=79715748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79715748",
  null
  
)

export default component.exports